import React from "react";
import ReactMarkdown from "react-markdown";

const MarkdownViewer = ({ children, className }) => {
  return (
    <p className={`prose ${className}`}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </p>
  );
};

export default MarkdownViewer;
